import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_TAGS_MONITOR_LOG: TDatadogErrorLog = {
  from: 'src/hooks/useTagsMonitor',
  name: 'Get Tags Monitor',
  message: 'Fetch tags monitor failed',
}
